import { useMemo, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { differenceInDays, isValid } from 'date-fns';
import { ERPJobFormValues } from '../../../ERPJobValidationSchema';

/**
 * Hook to calculate and sync overnightJob form value based on startDate and endDate
 */
export function useOvernightJob() {
  const { values, setFieldValue } = useFormikContext<ERPJobFormValues>();

  // Check if job is overnight (endDate is 1+ days after startDate)
  const isOvernightJob = useMemo(() => {
    if (!values.startDate || !values.endDate) return false;
    if (!isValid(values.startDate) || !isValid(values.endDate)) return false;
    const daysDifference = differenceInDays(values.endDate, values.startDate);
    return daysDifference >= 1;
  }, [values.startDate, values.endDate]);

  // Update overnightJob form value when dates change
  useEffect(() => {
    setFieldValue('overnightJob', isOvernightJob, false);
  }, [isOvernightJob, setFieldValue]);

  return isOvernightJob;
}
